import { render, staticRenderFns } from "./ActivityDesc.vue?vue&type=template&id=0dd8f0d2&scoped=true&"
import script from "./ActivityDesc.vue?vue&type=script&lang=js&"
export * from "./ActivityDesc.vue?vue&type=script&lang=js&"
import style0 from "./ActivityDesc.vue?vue&type=style&index=0&id=0dd8f0d2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0dd8f0d2",
  null
  
)

export default component.exports